import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-references',
  templateUrl: './references.component.html'
})
export class ReferencesComponent implements OnInit {

  @Output()
  formReady = new EventEmitter<FormGroup>();

  @Input() editReferences: any;

  constructor(private fb: FormBuilder) { }

  references:FormArray;
  formFields: any;

  form = this.fb.group({
    references: this.fb.array([this.createItem()])
  });

  ngOnInit(){
    this.addItem();
    this.formReady.emit(this.form);
    console.log(this.editReferences);
    if(this.editReferences?.references){
      let length = this.editReferences.references.length
      if( length > 2){
        length -= 2;
        while(length > 0 ){
          this.addItem();
          length -= 1;
        }
        this.form.patchValue(this.editReferences);
      }else{
        this.form.patchValue(this.editReferences);
      }
      
    }
    
  }

  getControls() {
    return (this.form.get('references') as FormArray).controls;
  }

 createItem(){
    let group = this.fb.group({});

    this.formFields = [
      {
        title: "Nombre",
        formControlName: "referenceName",
        type: "text"
      },
      {
        title: "Dirección",
        formControlName: "referenceAddress",
        type: "text"
      },
      {
        title: "Teléfono",
        formControlName: "referencePhone",
        type: "tel"
      },
      {
        title: "Parentezco",
        formControlName: "referenceRelation",
        type: "text"
      }
    ]
  
    for(let field of this.formFields){
      let formControl = new FormControl('',[Validators.required])
      group.addControl(field.formControlName, formControl);
    }
    return group;
  }

  addItem(){
    this.references = this.form.get('references') as FormArray;
    this.references.push(this.createItem());
    this.references.updateValueAndValidity();
  }

  removeRow(index:any) {
    console.log(index);
    (<FormArray>this.form.get("references")).removeAt(index);
  }

  

}
